/**
 * Wandelt ein JSON-Objekt mit Code-Schlüsseln in eine renderbare Optionsliste um.
 * Der ursprüngliche Code wird als eigenes Feld ergänzt und bleibt unverändert.
 */
export function entries(node) {
  return Object.entries(node || {}).map(([code, value]) => ({code: String(code), ...value}));
}

export function getScopes(tree) { return entries(tree); }
export function getProblems(tree, scope) { return entries(tree?.[scope]?.problems); }
export function getAges(tree, scope, problem) { return entries(tree?.[scope]?.problems?.[problem]?.ages); }
export function getMaterials(tree, scope, problem, age) { return entries(tree?.[scope]?.problems?.[problem]?.ages?.[age]?.materials); }

/** Liest die Empfehlungen des vollständig ausgewählten Pfads aus. */
export function getRecommendations(tree, selection) {
  return tree?.[selection.scope]?.problems?.[selection.problem]?.ages?.[selection.age]
    ?.materials?.[selection.material]?.recommendations || [];
}

/** Liest den sprachspezifischen Beratungstext des vollständigen Pfades. */
export function getAdvice(tree, selection) {
  return tree?.[selection.scope]?.problems?.[selection.problem]?.ages?.[selection.age]
    ?.materials?.[selection.material]?.advice || '';
}

/**
 * Erkennt den Sonderfall, in dem die Altersfrage fachlich nicht anwendbar ist.
 * Nur ein einzelner Ast mit Code 0 darf automatisch übersprungen werden.
 */
export function getAutomaticAge(ages) {
  return ages.length === 1 && ages[0].code === '0' ? '0' : null;
}

/**
 * Erzeugt eine eindeutige SKU-Liste für den nachgelagerten Katalogdatenabruf.
 * Leere, noch nicht gemappte Alt-Empfehlungen werden dabei ausgelassen.
 */
export function uniqueSkus(recommendations) {
  return [...new Set(recommendations
    // Reine Linkempfehlungen besitzen bewusst keine Katalogbindung und dürfen
    // deshalb niemals an den Produktdaten-Endpunkt weitergegeben werden.
    .filter((item) => item.type !== 'link')
    .map((item) => String(item.sku || '').trim())
    .filter(Boolean))];
}
